import { Navigate, Outlet } from "react-router-dom";
import { matchPath, useResolvedPath, useSearchParams } from "react-router-dom";

import { Stack } from "@mui/material";

import ROUTES from "@app/common/routes";
import { withQueryParams } from "@app/common/utils";
import useWorkspace from "@app/common/workspaces/useWorkspace";

import LoadSpinner from "@rui/LoadSpinner";

// this component captures anything under `/analytics/settings/workspace`
const WorkspaceSettingsRedirect = () => {
  const workspaceContext = useWorkspace();
  const [queryParams] = useSearchParams();

  const onWorkspaceSettingsRoot = matchPath(
    useResolvedPath(ROUTES.WORKSPACE_SETTINGS_ROOT).pathname,
    location.pathname
  );

  if (!onWorkspaceSettingsRoot) {
    // let the child routes handle any redirects that need to happen there, otherwise we get
    // flashes of a page before the redirect
    return <Outlet />;
  }

  if (workspaceContext.inWorkspace) {
    return (
      <Navigate
        to={withQueryParams(
          ROUTES.workspaceSettingsById(workspaceContext.workspaceId!),
          undefined,
          queryParams
        )}
      />
    );
  }

  // the wizard will redirect to this route directly after workspace create in order
  // to bypass the workspace settings/wizard component redirects. if there is any lag
  // between hitting this route and the context accepting the new workspace id, (should
  // not be noticeable to users), show a load spinner
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ mt: "60px", height: "100%", width: "100%", minHeight: "200px" }}
    >
      <LoadSpinner />
    </Stack>
  );
};

export default WorkspaceSettingsRedirect;
